import React, { useState } from 'react';
import { Input, FormGroup, Button, Label, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const SingleReject = ({ candidate, closeModal }) => {
  const navigate = useNavigate();

  // Initialize state with candidate details and form fields
  const [formData, setFormData] = useState({
    candidateId: candidate?.candidateId || 'N/A',
    candidateName: `${candidate?.generalInfoCandidateDto?.firstName || ''} ${
      candidate?.generalInfoCandidateDto?.lastName || ''
    }`.trim() || 'N/A',
    jobTitle: candidate?.job?.[0]?.jobTitle || 'N/A',
    source: candidate?.othersDto?.source || 'N/A',
    applicationId: candidate?.applicationId || 'N/A',
    appliedOn: candidate?.appliedDate || 'DD/MM/YYYY',
    round: '',
    rejectionReasons: [],
    additionalComments: '',
    feedbackToCandidate: '',
    sendRejectionEmail: false,
    doNotNotify: false,
  });

  // Handle changes for select inputs and text inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle changes for checkboxes (rejection reasons)
  const handleRejectionReasonChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      rejectionReasons: checked
        ? [...prev.rejectionReasons, value]
        : prev.rejectionReasons.filter((reason) => reason !== value),
    }));
  };

  // Handle changes for notification checkboxes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Handle form submission
  const handleSubmit = () => {
    // Prepare the data to send to the backend
    const submissionData = {
      candidateId: formData.candidateId,
      candidateName: formData.candidateName,
      jobTitle: formData.jobTitle,
      source: formData.source,
      applicationId: formData.applicationId,
      appliedOn: formData.appliedOn,
      round: formData.round,
      rejectionReasons: formData.rejectionReasons,
      additionalComments: formData.additionalComments,
      feedbackToCandidate: formData.feedbackToCandidate,
      sendRejectionEmail: formData.sendRejectionEmail,
      doNotNotify: formData.doNotNotify,
    };

    // Log the submission data (replace with API call)
    console.log('Form Submission Data:', submissionData);

    // Example: Send data to backend
    // try {
    //   await post(api.REJECT_CANDIDATE, submissionData);
    //   closeModal();
    // } catch (error) {
    //   console.error('Error submitting form:', error);
    // }

    // Close the modal after submission
    closeModal();
  };

  return (
    <div
      style={{
        minWidth: '640px',
        borderRadius: '32px',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
        padding: '32px',
      }}
    >
      <p
        className="heading"
        style={{
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '28px',
          marginBottom: '24px',
        }}
      >
        Reject Candidate
      </p>
      <Row className="p-3 m-0 mt-1 data">
        <Col size={6}>
          <p className="info-head">Candidate ID</p>
          <p className="info">{formData.candidateId}</p>
          <p className="info-head">Job Title</p>
          <p className="info">{formData.jobTitle}</p>
          <p className="info-head">Source</p>
          <p className="info">{formData.source}</p>
        </Col>
        <Col size={6}>
          <p className="info-head">Candidate Name</p>
          <p className="info">{formData.candidateName}</p>
          <p className="info-head">Application ID</p>
          <p className="info">{formData.applicationId}</p>
          <p className="info-head">Applied On</p>
          <p className="info">{formData.appliedOn}</p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <FormGroup>
            <Label
              style={{
                color: '#344054',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
              }}
            >
              Screening Round
            </Label>
            <Input
              type="select"
              name="round"
              value={formData.round}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="screening">Screening Round</option>
              {/* Add more options as needed */}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <p
          style={{
            color: '#222222',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0%',
          }}
        >
          Select a reason for rejection
        </p>
        <Col>
          <FormGroup className="d-flex gap-2">
            <Input
              id="1"
              className="checkbox"
              type="checkbox"
              value="Not a skill match"
              onChange={handleRejectionReasonChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="1"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Not a skill match
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="2"
              className="checkbox"
              type="checkbox"
              value="Experience below expectations"
              onChange={handleRejectionReasonChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="2"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Experience below expectations
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="3"
              className="checkbox"
              type="checkbox"
              value="Poor resume presentation"
              onChange={handleRejectionReasonChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="3"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Poor resume presentation
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="4"
              className="checkbox"
              type="checkbox"
              value="No relevant project work"
              onChange={handleRejectionReasonChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="4"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              No relevant project work
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="5"
              className="checkbox"
              type="checkbox"
              value="Others"
              onChange={handleRejectionReasonChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="5"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Others
            </Label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <p
              className="mb-1"
              style={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
              }}
            >
              Additional Comments
            </p>
            <p
              style={{
                fontWeight: 500,
                fontStyle: 'italic',
                fontSize: '10px',
                color: '#475467',
              }}
            >
              This will be visible to HR/recruitment team for future reference
            </p>
          </Row>
          <Row>
            <Input
              type="textarea"
              rows="4"
              name="additionalComments"
              value={formData.additionalComments}
              onChange={handleInputChange}
              placeholder="Comments"
              style={{ border: '1px solid #475467' }}
            />
          </Row>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Row>
            <p
              style={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
              }}
            >
              Feedback to Candidates
            </p>
          </Row>
          <Row>
            <Input
              type="textarea"
              rows="4"
              name="feedbackToCandidate"
              value={formData.feedbackToCandidate}
              onChange={handleInputChange}
              placeholder="Feedback"
              style={{ border: '1px solid #475467' }}
            />
          </Row>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="6"
              className="checkbox"
              type="checkbox"
              name="sendRejectionEmail"
              checked={formData.sendRejectionEmail}
              onChange={handleCheckboxChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="6"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Send rejection email to candidates
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              id="7"
              className="checkbox"
              type="checkbox"
              name="doNotNotify"
              checked={formData.doNotNotify}
              onChange={handleCheckboxChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              for="7"
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Do not notify candidates
            </Label>
          </FormGroup>
        </Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
        <Button
          onClick={closeModal}
          style={{
            backgroundColor: 'white',
            color: '#006438',
            border: '1px solid #006438',
            borderRadius: '12px',
            marginRight: '16px',
            width: '128px',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          style={{
            backgroundColor: '#006438',
            color: '#FFFFFF',
            borderRadius: '12px',
            width: '128px',
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default SingleReject;